<div class="confirmation-message">
  <fa-icon [icon]="['fas', 'info-circle']"></fa-icon>
  <span>{{ "widget-actions.to-same-feed.confirm-message" | translate }}</span>
</div>

<div class="table-container">
  <table class="table table-bordered table-hover">
    <thead class="table-header-sticky">
      <tr>
        <th scope="col" class="col-widget-title">
          {{ "widget-actions.to-same-feed.col-widget-title" | translate }}
        </th>
        <th scope="col" class="col-action">
          {{ "widget-actions.to-same-feed.col-action" | translate }}
        </th>
      </tr>
    </thead>

    <tbody>
      @for (widget of widgets; track widget) {
        <tr>
          <!-- Widget Title Column -->
          <td class="widget-title-cell">
            <div class="widget-title-content">
              <fa-icon
                [icon]="['fas', 'chart-bar']"
                class="widget-icon"
              ></fa-icon>
              <span class="widget-title">{{ widget.title }}</span>
            </div>
          </td>
          <!-- Action Column -->
          <td class="action-cell">
            <div class="action-display">
              <span class="action-badge">{{
                "widget-actions.to-same-feed.action-badge" | translate
              }}</span>
            </div>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
